import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import Promotion from "../image-banner/Promotion";
import CategoriesSlider from "./CategoriesSlider"

const Products = () => {
  const [products, setProducts] = useState([]);    

  useEffect(() => {
    const getProducts = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const result = await axios.get(process.env.REACT_APP_API_URL + "/product/")
          .then((res) => {
            setProducts(res.data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    getProducts();
  }, []);

  return (
    <div className="products mx-2 lg:mx-20 ">
     
        
      <CategoriesSlider title="Gaming" products={useMemo(() => products
        ?.filter((product) => product.categories.includes("gaming")).slice(0,9), [products])} />
      
      <CategoriesSlider title="Computer" products={useMemo(() => products
        ?.filter((product) => product.categories.includes("laptop","computer", "pc")).slice(0,9), [products])} />

      <Promotion/>

      <CategoriesSlider title="All products" products={products}/>


    </div>
  );
};

export default Products;
